var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_244_33494",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_244_33494)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.53333H24V0H0V8.53333Z",
    fill: "#E12237"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71422 7.46665C6.5243 7.46665 7.26877 7.20443 7.8555 6.76598C7.5447 6.87418 7.20829 6.93332 6.85707 6.93332C5.27912 6.93332 3.99993 5.73942 3.99993 4.26666C3.99993 2.7939 5.27912 1.59999 6.85707 1.59999C7.2083 1.59999 7.54472 1.65914 7.85553 1.76735C7.2688 1.32888 6.52432 1.06665 5.71422 1.06665C3.82067 1.06665 2.28564 2.49934 2.28564 4.26665C2.28564 6.03396 3.82067 7.46665 5.71422 7.46665ZM6.85707 3.73332C6.85707 4.02787 6.60124 4.26665 6.28565 4.26665C5.97005 4.26665 5.71422 4.02787 5.71422 3.73332C5.71422 3.43877 5.97005 3.19999 6.28565 3.19999C6.60124 3.19999 6.85707 3.43877 6.85707 3.73332ZM7.4285 6.39998C7.74409 6.39998 7.99993 6.1612 7.99993 5.86665C7.99993 5.57209 7.74409 5.33331 7.4285 5.33331C7.11291 5.33331 6.85707 5.57209 6.85707 5.86665C6.85707 6.1612 7.11291 6.39998 7.4285 6.39998ZM10.2856 5.86665C10.2856 6.1612 10.0298 6.39998 9.71422 6.39998C9.39862 6.39998 9.14279 6.1612 9.14279 5.86665C9.14279 5.57209 9.39862 5.33331 9.71422 5.33331C10.0298 5.33331 10.2856 5.57209 10.2856 5.86665ZM10.8571 4.26665C11.1727 4.26665 11.4285 4.02787 11.4285 3.73332C11.4285 3.43877 11.1727 3.19999 10.8571 3.19999C10.5415 3.19999 10.2856 3.43877 10.2856 3.73332C10.2856 4.02787 10.5415 4.26665 10.8571 4.26665ZM9.14279 2.13332C9.14279 2.42788 8.88695 2.66666 8.57136 2.66666C8.25577 2.66666 7.99993 2.42788 7.99993 2.13332C7.99993 1.83877 8.25577 1.59999 8.57136 1.59999C8.88695 1.59999 9.14279 1.83877 9.14279 2.13332Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSg);
export default __webpack_public_path__ + "static/media/SG.8f65470420de96ff63979b8436592948.svg";
export { ForwardRef as ReactComponent };